import { ServiceTypeLabel } from '../../../../../types/api';

export type BasicServiceTypes = 'walk' | 'boarding' | 'sitting' | 'drop-in'

export const allServices = [
  {
    label: 'Walk' as ServiceTypeLabel,
    price: '$16.50',
    icon: 'https://assets.wagwalking.com/walker-profile/walk-service-img%403x.png',
    name: 'walk',
    serviceType: 'walk_express',
    allowedCustomService: null,
    value: 'walk_express' as BasicServiceTypes,
  },
  {
    label: 'Drop-In' as ServiceTypeLabel,
    price: '$16.50',
    icon: 'https://assets.wagwalking.com/walker-profile/drop-in-service-img%403x.png',
    name: 'drop-in',
    serviceType: 'drop_in',
    allowedCustomService: null,
    value: 'drop-in' as BasicServiceTypes,
  },
  {
    label: 'Sitting' as ServiceTypeLabel,
    price: '*$59.00',
    icon: 'https://assets.wagwalking.com/walker-profile/sitting-service-img%403x.png',
    name: 'sitting',
    serviceType: 'sitting',
    allowedCustomService: null,
    value: 'sitting' as BasicServiceTypes,
  },
  {
    label: 'Boarding' as ServiceTypeLabel,
    price: '*$79.00',
    icon: 'https://assets.wagwalking.com/walker-profile/boarding-service-img%403x.png',
    name: 'boarding',
    serviceType: 'boarding',
    allowedCustomService: null,
    value: 'boarding' as BasicServiceTypes,
  },
];
